import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import clsx from 'clsx'
import React, {
  Fragment,
  FunctionComponent,
  Suspense,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../common/js/Button'
import MobileModal from '../../../../../common/js/MobileModal'
import { Material } from './materials'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    materialRow: {
      cursor: 'pointer',
      width: '95%',
      margin: '8px auto',
      border: '2px solid white',
      borderRadius: '5px',

      '&:first-child': {
        marginTop: '16px',
      },

      '&:hover': {
        backgroundColor: '#cce4f6',
        borderRadius: '5px',
      },
    },
    materialRowSelected: {
      border: '2px solid #004b9d',
    },
  })
)

export interface IProps {
  defaultMaterial: string
  materials: Material[]

  onCancel: () => void
  onApply: (chosenMaterial: string) => void
}

const MaterialList: FunctionComponent<IProps> = (props: IProps) => {
  const { t } = useTranslation('PricingCalculator')
  const { t: tMaterials } = useTranslation('Materials')

  const classes = useStyles()
  const [chosenMaterial, setChosenMaterial] = useState(props.defaultMaterial)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const refs = props.materials.map(() => useRef<HTMLDivElement>())

  useEffect(() => {
    if (chosenMaterial !== props.defaultMaterial) {
      return
    }

    console.log('useEffect')
    const materialIndex = props.materials.findIndex(
      (m) => m.id === chosenMaterial
    )

    if (materialIndex >= 3) {
      const e = document.querySelector(
        isMobile ? '.material-chooser' : '.material-chooser-wrap'
      )
      e.scrollTop = refs[materialIndex].current.offsetTop + 100 //  (refs[materialIndex].current.offsetHeight*1.5)
      console.log(
        'Set scrolltop to',
        e.scrollTop,
        refs[materialIndex].current.offsetTop
      )
    }
  })

  const buttons = (
    <Fragment>
      <div className="si-col si-col-6">
        <Button
          data-pricingcalculator-element={'material-chooser-cancel'}
          variant="outlined"
          fullWidth={true}
          color="transparent"
          onClick={props.onCancel}
        >
          {t('material-chooser-cancel')}
        </Button>
      </div>
      <div className="si-col si-col-6">
        <Button
          data-pricingcalculator-element={'material-chooser-apply'}
          fullWidth={true}
          color="coolBlue"
          onClick={() => {
            props.onApply(chosenMaterial)
          }}
        >
          {t('material-chooser-apply')}
        </Button>
      </div>
    </Fragment>
  )

  return (
    <MobileModal
      fullPage={false}
      onClose={(evt: Event) => {
        evt.preventDefault()
        props.onCancel()
      }}
      buttons={buttons}
    >
      <div data-pricingcalculator-element={'material-chooser'}>
        <div className="si-text-centered">
          <h3>{t('material-chooser-title')}</h3>
          <p className="si-text-body1">{t('material-chooser-subtitle')}</p>
        </div>
        {props.materials.map(
          ({ id: materialId, name, desc, bestseller }, idx) => {
            return (
              <div
                ref={refs[idx]}
                data-pricingcalculator-element={'material'}
                data-pricingcalculator-materialId={materialId}
                className={clsx(
                  'si-row si-row-no-wrap si-margin',
                  classes.materialRow,
                  {
                    [classes.materialRowSelected]: chosenMaterial == materialId,
                  }
                )}
                key={materialId}
                onClick={() => {
                  setChosenMaterial(materialId)
                }}
              >
                <div style={{ margin: '8px', display: 'flex' }}>
                  <div className="si-col-3">
                    <picture>
                      <source
                        type="image/png"
                        srcSet={`/wp-content/themes/stickerit-gb/assets/images/material-${materialId}.png`}
                      />
                      <img
                        width="114"
                        loading="lazy"
                        src={`/wp-content/themes/stickerit-gb/assets/images/material-${materialId}.png`}
                      />
                    </picture>
                  </div>
                  <div className="si-col-9">
                    <div className="si-padded-left">
                      <h4 style={{ marginLeft: 0 }}>
                        {tMaterials(`${materialId}.name`)}
                      </h4>
                      <p className="si-text-body2">
                        {tMaterials(`${materialId}.shortDescription`)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        )}
      </div>
    </MobileModal>
  )
}

export default MaterialList
